import React, { Component } from 'react';
import * as $ from 'jquery';
import moment from 'moment-timezone';
import spinner from '../../images/loading-spinner.gif';
import { ROOM_TYPE } from './RoomsContainer.js';
import { translate } from 'react-i18next';
import brandLogo from '../../images/brand-logo-inverse-light.png';
import TimeOptions from '../../components/TimeOptions/index.jsx';

class RoomSearch extends Component {

  constructor(props) {
    super(props);
    this.state = {
      inpustDateCowork: false,
    }
  }

  componentDidMount() {
    $('#date').datepicker({
      onSelect: (d, i) => {
        if (d !== i.lastVal) {
          this.props.handleDateChange(d);
        }
      }
    });
    //$('#btnCOVIDMessage').click();
  }


  isSearchEnabled = () => {
    switch (this.props.roomType) {
      case ROOM_TYPE.COWORK:
        return !this.props.isSearching
          && this.props.center
          && this.props.date;

      default:
      case ROOM_TYPE.MEETING_ROOM:
        return !this.props.isSearching
          && this.props.center
          && this.props.date
          && this.props.time
          && moment(this.props.date + " " + this.props.time, 'MM/DD/YYYY HH:mm') > moment()
          && this.props.duration;
    }
  }

  renderCenter = (center, index) => {
    return (
      <li key={index}>
        <a onClick={() => this.props.handleCenterClick(center)}>
          {center.name}
        </a>
      </li>
    );
  }

  lopInputs = () => {
    const numInputs = this.props.numDays;
    const inputsDate = [];
    for (var a = 2; a <= numInputs; a++) {
      inputsDate.push(this.renderTimePickerCowork(a));
    }
    return (
      <table style={{ width: '100%' }}>
        <tbody>{inputsDate}</tbody>
      </table>
    );
  }

  createChangeInput = () => {
    const numInputsDate = this.props.numDays;
    for (var a = 2; a <= numInputsDate; a++) {
      $('#dateCowork_' + a).datepicker({
        onSelect: (d, i) => {
          if (d !== i.lastVal) {
            this.props.handleDateChangeCowork(d, i.input[0]);
          }
        }
      });
    }
  }

  // Input timepicker
  renderTimePickerCowork = (num) => {
    return (
      <tr className="form-group" key={num}>
        <td>
          <label htmlFor={'dateCowork_' + num}> Fecha de reservación del día <b>{num}</b></label>
          <input autoComplete="off" className="form-control" id={'dateCowork_' + num} onChange={(e) => this.props.handleDateChangeCowork(e.target.value, e.target)} placeholder={'MM/DD/AAAA'} required type="text" />
          {/* {this.props.date} */}
        </td>
      </tr>
    );
  }
  // Options days
  renderSelectCowork = () => {
    return (
      <select onChange={this.props.handleSelectCowork} className="form-control">
        {optionSelect.map(option => {
          return <option value={option.id} key={option.id} >{option.stringSelect}</option>
        })
        }
      </select>
    );
  }


  render() {
    const { t } = this.props;
    const center = this.props.center;
    var today = new Date();
    const min_date =  moment(today, 'MM/DD/YYYY').format('YYYY-MM-DD')
    const new_date = moment(this.props.date, 'MM/DD/YYYY').format('YYYY-MM-DD')
    return (
      <div className="jumbotron panel-search-resvations">
        <div className="row">
          <div className="col-md-6">
            <form method="post" onSubmit={this.props.handleRoomSearch}>
              <fieldset>
                <div className="form-group">
                  <label htmlFor="center">
                    {t('dashboard.reservations.label_center')}
                  </label>
                  <div id="dropdown-div" className="dropdown">
                    <input
                      autoComplete="off"
                      className="dropdown-toggle form-control"
                      data-toggle="dropdown"
                      id="center"
                      onChange={this.props.handleCenterSearch}
                      onClick={() => { $("#dropdown-div").addClass("open") }}
                      placeholder={t('dashboard.reservations.holder_center')}
                      required
                      type="search"
                      value={this.props.centerQuery ? this.props.centerQuery : ''} />
                    <ul id="center-results" className="dropdown-menu" style={{ display: 'none' }}>
                      {this.props.centers.map((center, index) => this.renderCenter(center, index))}
                    </ul>
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="date">
                    {t('dashboard.reservations.label_date')}
                  </label>
                  <input
                    autoComplete="off"
                    className="form-control"
                    onChange={(e) => this.props.handleDateChange(e.target.value)}
                    placeholder={t('dashboard.reservations.holder_date')}
                    required
                    type="date"
                    min = {min_date}
                    value={new_date} />
                </div>
                <div className="form-group">
                  <label htmlFor="time">
                    {t('dashboard.reservations.label_time')}
                  </label>
                  <select
                    className="form-control"
                    id="time"
                    onChange={this.props.handleTimeChange}
                    required
                    value={this.props.time}>
                      <TimeOptions date={this.props.date} />
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="duration">
                    {t('dashboard.reservations.label_duration')}
                  </label>
                  <select
                    className="form-control"
                    id="duration"
                    onChange={this.props.handleDurationChange}
                    required
                    value={this.props.duration}>
                    {this.props.durations.map((duration, index) => <option key={index} value={duration.id}>{duration.name}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <button
                    className="btn btn-primary btn-search-resvations"
                    type="submit">
                    {t('dashboard.reservations.btn_search')}
                  </button>
                  <div className={this.props.isSearching ? "demo-container" : "hidden"}>
                    <div className="progress-bar">
                      <div className="progress-bar-value"></div>
                    </div>
                  </div>
                </div>
                <div className={this.props.error ? "" : "hidden"}>
                  <div className="form-group">
                    <div className="alert alert-warning">
                      <i className="glyphicon glyphicon-remove pull-right" onClick={this.props.handleClearError} />
                      {this.props.error}
                    </div>
                  </div>
                </div>
              </fieldset>
            </form>
          </div>
          <div className="col-md-6">
            <div className="iframe-wrapper">
              <iframe
                frameBorder="0"
                src={
                  "https://www.google.com/maps/d/embed?mid=1Cd02Lz4Q-XK73pQs9iA5jMJk86k&ll="
                  + (center ? center.latitude : "0")
                  + "%2C"
                  + (center ? center.longitude : "0")
                }
                title={t('dashboard.reservations.frame_center')}>
              </iframe>
            </div>
          </div>
        </div>

        <button
          className="hidden"
          data-target="#modalCOVID"
          data-toggle="modal"
          id="btnCOVIDMessage"
          type="button">
        </button>
        <div className="modal fade" id="modalCOVID" role="dialog" style={{ textAlign: "left" }}>
          <div className="modal-dialog COVID">
            <div className="modal-content">
              <div className="modal-header COVID-HEADER">
                <button type="button" className="close btn-primary" data-dismiss="modal" aria-label="Close"><span aria-hidden="true" style={{ fontSize: '30px', background: 'red', width: '30px', display: 'block' }}>&times;</span></button>
                <div className="navbar-header">
                  <div className="navbar-brand">
                    <img alt="IOS OFFICES" className="brand-logo" src={brandLogo} />
                  </div>
                </div>
              </div>
              <div className="modal-body">
                <h4>Apreciable Comunidad IOS,</h4>
                <p>Sabemos lo importante que es cuidar su bienestar y el de toda la Comunidad IOS. <br />Como medidas de prevención, todas las salas de juntas y oficinas se encontrarán <br />con un sello para comprobar que han sido desinfectadas.</p>
                <p>En caso de tener una reunión, te agradecemos seguir los siguientes puntos para <br />llevar una junta segura:</p>
                <ol style={{ fontSize: '16px', color: '#798395' }}>
                  <li>Ocupar solo el 50% de la capacidad de la sala.<br />(Ej. Sala con capacidad de 4 personas, solo entran 2).</li>
                  <li>Mantén tu distancia dentro de la sala de juntas.</li>
                  <li>Utiliza antibacterial para desinfectar tus manos.</li>
                  <li>Durante la reunión, utiliza cubrebocas.</li>
                </ol>
                <p>Al finalizar, ten por seguro que nuestro equipo desinfectara el espacio. <br />Estamos juntos en esto. ¡Gracias por cuidar la salud de todos!</p>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-primary btn-search-resvations"
                  data-dismiss="modal"
                  type="button">
                  Enterado
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default translate('common')(RoomSearch);

const datePlan = {
  fontSize: 'smaller',
  fontStyle: 'initial',
  color: '#00bcd4'
}

const optionSelect = [
  { id: 1, stringSelect: '1 día' }, { id: 2, stringSelect: '2 días' }, { id: 3, stringSelect: '3 días' }, { id: 4, stringSelect: '4 días' },
  { id: 5, stringSelect: '5 días' }, { id: 6, stringSelect: '6 días' }, { id: 7, stringSelect: '7 días' }, { id: 8, stringSelect: '8 días' },
  { id: 9, stringSelect: '9 días' }, { id: 10, stringSelect: '10 días' }, { id: 11, stringSelect: '11 días' }, { id: 12, stringSelect: '12 días' }
];


// WEBPACK FOOTER //
// ./src/dashboard/reservations/RoomSearch.js